import './google-maps.scss';

import * as $gzGoogleMaps from './google-maps.service';
import * as gzGoogleMap from './google-map.directive';
import * as gzPlacesAutoComplete from './places-auto-complete.directive';

export default angular.module('gazelle.components.googleMaps', [
  'ui.router',
  'rhino.core',
  'rhino.components.locale',
])
  .factory($gzGoogleMaps.name, $gzGoogleMaps.default)
  .directive(gzGoogleMap.name, gzGoogleMap.default)
  .directive(gzPlacesAutoComplete.name, gzPlacesAutoComplete.default)
  .name;
